<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>

                <rkm-col cols="2">
                    <rkm-form-select
                        label="Tipo de busca"
                        text-field="text"
                        value-field="value"
                        v-model="model.tipoBusca"
                        :options="data.form.tipoBusca"
                        :validations="validations.tipoBusca"
                        @change="handleTipoBusca()"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-date-picker
                        range
                        :range-inline="false"
                        :start-label="startLabel"
                        end-label="Até"
                        v-model="model.periodo"
                        :max-date="data.form.dataAtual"
                        :start-validations="validations.periodo.start"
                        :end-validations="validations.periodo.end"
                    />
                </rkm-col>

                <rkm-col cols="6" >
                    <rkm-form-input-autocomplete
                        :searchFields="localForm.autocompleteFields.paciente"
                        :repository="repositories.paciente"
                        v-model="paciente"
                        :text-field="(item) =>  item.cidadao.cns
                            ? `${this.formatCns(item.cidadao.cns)} - ${item.cidadao.nome}`
                            : item.cidadao.nome"
                        label="Paciente"
                        uppercase
                        @select="setListagem()"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="unidade"
                        label="Laboratório"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.unidadeId"
                        value-field="id"
                        :validations="validations.unidade"
                        :disabled="disabled"
                        @change="setListagem()"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        label="Local de atendimento"
                        :options="infraestrutura"
                        textField="nome"
                        v-model="model.infraestruturaId"
                        valueField="id"
                        show-default-option
                        :validations="validations.infraestrutura"
                        :disabled="disabled"
                        @change="setListagem()"
                    />
                </rkm-col>

            </rkm-row>

            <rkm-row class="flex-nowrap">

                <rkm-col cols="3">
                    <rkm-form-input
                        label="Prontuário"
                        v-model="model.prontuario"
                        number
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        label="Número do agendamento"
                        v-model="model.agendamentoNumero"
                        number
                    />
                </rkm-col>

                <rkm-col class="flex-grow-1">
                    <rkm-form-select
                        label="Status"
                        text-field="text"
                        value-field="value"
                        v-model="model.status"
                        :options="data.form.status"
                        default-option-text="TODOS"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        color="primary"
                        @click="$refs.Form.validate(search)"
                    >
                        Buscar
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click="resetForm()"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            v-if="itemsNotSave"
            :items="itemsNotSave || items"
            :fields="fields"
            sort-by="data"
            hide-filters
        >
            <template v-slot:cell(actions)="{ item }">

                <rkm-button
                    color="primary"
                    small
                    title="Importar laudo"
                    @click="$refs.ModalLaudo.open(item, false)"
                >
                    <rkm-icon icon="upload" />
                </rkm-button>

                <rkm-button
                    color="secondary"
                    small
                    title="Detalhamento"
                    @click="$refs.Modal.open(item)"
                >
                    <rkm-icon icon="search" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            ref="Modal"
        />

        <ModalLaudo
            ref="ModalLaudo"
        />
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { repository, error, object, formats, data, stringCase } from '@/mixins'

// Moment.
import moment from 'moment'

// Enums.
import statusAgendamento from '@/enums/exame-laboratorial/statusAgendamento'
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

// Components.
import Modal from '@/components/exame-laboratorial/importar-laudo/Modal'
import ModalLaudo from '@/components/exame-laboratorial/importar-laudo/components/Modal'

export default {
    components:{ Modal, ModalLaudo },
    computed: {
        fields() {
            const fields = [
                {
                    key: "data",
                    label: "Data da coleta",
                    class: 'col-min text-center',
                    sortable: true
                },
                {
                    key: "agendamentoNumero",
                    label: "Agendamento",
                    class: 'col-min text-center',
                    sortable: true
                },
                {
                    key: "pacienteProntuario",
                    label: "Prontuário",
                    class: 'col-min text-center',
                    sortable: true
                },
                {
                    key: "pacienteNome",
                    label: "Paciente",
                    sortable: true
                },
                {
                    key: "status",
                    label: "Status",
                    sortable: true
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                }
            ]

            return fields
        },
        validations() {

            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                },
                profissional: { required: true },
                unidade: { required: true },
                infraestrutura: { required: true },
                tipoBusca: { required: true },
            }
        },
        startLabel() {

            return this.model.tipoBusca === 'importacao'
                ? 'Data de importação, de'
                : 'Data de coleta, de'
        },
        infraestrutura() {

            this.setInfraestrutura()

            if (this.model.unidadeId) {

                let infraestruturaPrincipal = this.unidade.find(u => u.id == this.model.unidadeId).infraestruturas

                this.handleInfraestrutura(infraestruturaPrincipal)

                return infraestruturaPrincipal
            }

            return []
        },
    },
    created() {

        this.repositories = {
            laudo: this.getConectaSusRepository('exameLaboratorial.importarLaudo'),
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
        },

        this.load();
    },
    data() {
        return {
            model: {
                pacienteId: null,
                profissionalId: null,
                unidadeId: null,
                infraestruturaId: null,
                prontuario: null,
                agendamentoNumero: null,
                status: null,
                statusId: null,
                tipoBusca: 'coleta',
                periodo: {
                    start: null,
                    end: null,
                },
            },
            saveAgendamento: {
                agendamentos: [],
            },
            paciente: null,
            disabled: false,
            unidade: [],
            itemsNotSave: [],
            localForm: {
                autocompleteFields: {
                    usuario: [
                        { key: "cadastroCidadao.nome", searchable: true },
                    ],
                    paciente: [
                        { key: 'cidadao.nome', searchable: true },
                    ],
                },
            },
            enums: {
                statusAgendamento,
                preferenciaNome
            },
            unwatchers: {
                modelPeriodoEnd: null,
                modelPeriodoStart: null,
            },
        }
    },
    mixins: [repository, error, object, formats, data, stringCase],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.model.periodo = this.data.form.periodo

            if (this.data.form.profissional) {

                this.model.profissionalId = this.data.form.profissional.id
            }

            this.$nextTick()
                .then(() => this.loadFields())
                .then(() => this.addWatchers())
        },
        prepareData() {

            if (this.itemsNotSave && this.itemsNotSave.length > 0) {

                this.saveAgendamento.agendamentos = this.clone(this.itemsNotSave)

                const notSave = this.saveAgendamento

                return this.camelObjectKeysToSnakeRecursive(notSave)
            } else {

                const model = this.clone(this.data.model)

                return this.camelObjectKeysToSnakeRecursive(model)
            }
        },
        search() {

            this.setLoading()

            this.repositories.laudo.list(this.getSearchParams())
                .then(({ data }) => {

                    this.itemsNotSave = data.model.agendamentos
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        validate() {

            return this.$refs.Form.validate()
        },
        getSearchParams() {

            const params = this.clone(this.model)

            if (this.paciente) {

                params.pacienteId = this.paciente.id
                params.pacienteNome = this.paciente.cidadao.nome
            }

            this.formateDates(params.periodo, ['start', 'end'], 'YYYY-MM-DD')

            return this.camelObjectKeysToSnakeRecursive(params)
        },
        resetForm() {

            this.model.exame = null
            this.paciente = null
            this.model.usuario = null
            this.model.status = null
            this.model.agendamentoNumero = null
            this.model.prontuario = null
            this.model.tipoBusca = 'coleta'
            this.itemsNotSave = null

            this.setDefaultValues()

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        setDefaultValues() {

            this.model.periodo.start = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
            this.model.periodo.end = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
        },
        loadFields() {

            this.setLoading()

            this.repositories.laudo.load(this.getSearchParams())
                .then(({ data }) => {

                    this.unidade = data
                    this.handleLaboratorio(data)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setListagem() {

            this.itemsNotSave = null
        },
        handleTipoBusca() {

            this.setListagem()

            if (this.model.periodo.start && this.model.periodo.end) {

                this.loadFields()
            }
        },
        handleLaboratorio(unidade) {

            let unidadeLogada = unidade.find(u => u.id === this.data.form.unidadeId)

            if (unidadeLogada) {

                this.model.unidadeId = this.data.form.unidadeId
            }
        },
        handleInfraestrutura(infraestruturaPrincipal) {

            if (infraestruturaPrincipal) {

                let infraestrutura = infraestruturaPrincipal.find(u => u.id == this.data.form.infraestruturaId)

                if (infraestrutura) {

                    this.model.infraestruturaId = this.data.form.infraestruturaId
                } else if (infraestruturaPrincipal.find(u => u.principal)) {

                    this.model.infraestruturaId = infraestruturaPrincipal.find(u => u.principal).id
                }
            }
        },
        setInfraestrutura() {

            this.model.infraestruturaId = null
        },
        openMultiple() {

            this.$refs.ModalLaudo.open(null, true)
        },
        addWatchers() {

            this.addModelPeridoStartWatcher()
            this.addModelPeridoEndWatcher()
        },
        addModelPeridoStartWatcher() {

            this.unwatchers.modelPeriodoStart = this.$watch('model.periodo.start', function () {

                this.setListagem()

                if (this.model.periodo.start && this.model.periodo.end) {

                    this.loadFields()
                }

            })
        },
        addModelPeridoEndWatcher() {

            this.unwatchers.modelPeriodoEnd = this.$watch('model.periodo.end', function () {

                this.setListagem()

                if (this.model.periodo.start && this.model.periodo.end) {

                    this.loadFields()
                }

            })
        },
    },
    props: {
        data: { type: Object, required: true }
    },
}
</script>

<style scoped>
.table-td {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    border-top: 1px solid #ccc;
    font-weight: 600;
}
.table-border-top {
    border-top: 0;
    height: 30px;
    padding: 0;
}
.table-width {
    width: 100%;
}
</style>